export default function findUserPresenceBlock(editor, blockId) {
  const block = editor.value.document.findDescendant(
    node => node.getIn(['data', 'id']) === blockId
  )
  return block
}
